import axios from "axios";
import buildSearchRequestUrl from "@js/parts/search/functions/buildSearchRequestUrl";

export function performSearch(context,request) {
	const overwrite = typeof request.overwrite !== 'boolean' ? true : request.overwrite;
	const fetchAll = typeof request.fetchAll !== 'boolean' ? false : request.fetchAll;
	return new Promise((resolve, reject) => {
		axios({ method: 'GET', url: buildSearchRequestUrl(context.state.search.queryParameters,context.state.prPage,context.state.page,context.state.search.searchOrder,fetchAll), headers: {'Content-Type': 'application/json'}})
		.then(response => {
			if(overwrite)
			{
				context.commit('setTotalCount',response.data.total);
				context.commit('setAltCount',response.data.altCount);
				context.commit('setMaxPages',response.data.maxPage);
				context.commit('setLodgings',response.data.result);
				context.commit('setPrintIds',response.data.idList);
			}
			else
			{
				context.commit('addLodgings',response.data.result);
			}
			resolve(response.data);
		})
		.catch(error => {
			reject(error);
		});
	});
}
